import { useTranslation } from "react-i18next";import React, { useState } from 'react';
import { Input } from '@/shared/components/ui/input';
import { Button } from '@/shared/components/ui/button';
import { Scan, Search } from 'lucide-react';
import { cn } from '@/shared/utils';

export const ScanInput = ({
  placeholder = 'Scan barcode or enter SKU...',
  onScan,
  onSearch,
  className,
  autoFocus = true
}) => {const { t } = useTranslation("wms");
  const [value, setValue] = useState('');
  const [isScanning, setIsScanning] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (value.trim()) {
      onScan?.(value.trim());
      setValue('');
    }
  };

  const handleScanClick = () => {
    setIsScanning(true);
    // Simulate scanner activation
    setTimeout(() => setIsScanning(false), 2000);
  };

  return (
    <form onSubmit={handleSubmit} className={cn("flex gap-2", className)}>
      <div className="relative flex-1">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
        <Input
          value={value}
          onChange={(e) => setValue(e.target.value)}
          placeholder={placeholder}
          className="pl-10 h-11 bg-background"
          autoFocus={autoFocus}
          data-testid="scan-input" />
        
      </div>
      <Button
        type="button"
        variant="outline"
        onClick={handleScanClick}
        className={cn(
          "h-11 px-4 gap-2",
          isScanning && "bg-blue-50 border-blue-300 text-blue-600"
        )}
        data-testid="scan-barcode-btn">
        
        <Scan className={cn("h-4 w-4", isScanning && "animate-pulse")} />
        <span className="hidden sm:inline">{t("scan", "Scan")}</span>
      </Button>
      <Button
        type="submit"
        className="h-11 px-6 bg-[hsl(var(--accent))] hover:bg-[hsl(var(--accent-hover))]"
        data-testid="process-scan-btn">{t("process", "Process")}


      </Button>
    </form>);

};